import React from 'react';

export default ({ className, ...rest }) => (
  <span className={className} {...rest}>
    <svg x="0px" y="0px" viewBox="0 0 100 100">
      <path d="M97.86,94.48L53.38,50L97.86,5.52c0.45-0.45,0.7-1.05,0.7-1.69c0-0.64-0.25-1.24-0.7-1.69c-0.93-0.93-2.45-0.93-3.38,0
    L50,46.62L5.52,2.14c-0.93-0.93-2.45-0.93-3.38,0c-0.45,0.45-0.7,1.05-0.7,1.69c0,0.64,0.25,1.24,0.7,1.69L46.62,50L2.15,94.48
    c-0.93,0.93-0.93,2.45-0.03,3.35c0.44,0.46,1.06,0.73,1.71,0.73c0.62,0,1.24-0.25,1.69-0.7L50,53.38l44.46,44.46
    c0.44,0.46,1.06,0.73,1.71,0.73c0.62,0,1.21-0.24,1.69-0.7C98.79,96.93,98.79,95.41,97.86,94.48z"/>
    </svg>
  </span>
);
